/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PROFILE_TAB = "ACCOUNT" | "MY_COMMENTS" | "PREFERENCES" | "%future added value";
export type TAB = "COMMENTS" | "PROFILE" | "%future added value";
export type NotificationsPaginatorLocal = {
    readonly activeTab: TAB;
    readonly profileTab: PROFILE_TAB;
    readonly hasNewNotifications: boolean | null;
    readonly " $refType": "NotificationsPaginatorLocal";
};
export type NotificationsPaginatorLocal$data = NotificationsPaginatorLocal;
export type NotificationsPaginatorLocal$key = {
    readonly " $data"?: NotificationsPaginatorLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"NotificationsPaginatorLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsPaginatorLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activeTab",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profileTab",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNewNotifications",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '89a01f034cc322575ae37ba22190ae1f';
export default node;
